import type { ConfirmRoundRecapAction } from "../types/action";
import type { ValidationResult } from "../types/common";
import type { HorrorRaceState } from "../types/game-state";

export function validateConfirmRoundRecap(
  state: HorrorRaceState,
  action: ConfirmRoundRecapAction,
): ValidationResult {
  if (state.phase !== "ROUND_RECAP") {
    return { valid: false, error: "Not in round recap phase" };
  }

  const player = state.players.find((p) => p.id === action.playerId);
  if (!player) {
    return { valid: false, error: "Player not found" };
  }

  if (player.hasConfirmedRoundRecap) {
    return {
      valid: false,
      error: "Player has already confirmed the round recap",
    };
  }

  return { valid: true };
}
